// src/components/Sidebar.jsx
import React from "react";
import { Drawer, List, ListItemButton, ListItemText, Toolbar } from "@mui/material";
import { useNavigate } from "react-router-dom";

const drawerWidth = 240;

export default function Sidebar() {
  const navigate = useNavigate();
  const rol = (localStorage.getItem("rol") || "").toLowerCase();

  const itemsByRole = {
    administrador: [
      { label: "Panel Admin", path: "/dashboard/administrador" },
      { label: "Empleados", path: "/dashboard/administrador?tab=empleados" },
      { label: "Percepciones", path: "/dashboard/administrador?tab=percepciones" },
      { label: "Deducciones", path: "/dashboard/administrador?tab=deducciones" }
    ],
    gerente: [
      { label: "Panel Gerencial", path: "/dashboard/gerente" },
      { label: "Percepciones", path: "/dashboard/gerente?tab=percepciones" },
      { label: "Deducciones", path: "/dashboard/gerente?tab=deducciones" }
      // Más adelante: horarios, incidencias
    ],
    empleado: [
      { label: "Mi Panel", path: "/dashboard/empleado" },
      { label: "Mis Percepciones", path: "/dashboard/empleado?tab=percepciones" },
      { label: "Mis Deducciones", path: "/dashboard/empleado?tab=deducciones" }
    ]
  };

  const items = itemsByRole[rol] || [];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth, flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" }
      }}
    >
      <Toolbar />
      <List>
        {items.map((item) => (
          <ListItemButton key={item.path} onClick={() => navigate(item.path)}>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </List>
    </Drawer>
  );
}
